import olfFeatures from "../../olfFeatures";

const login = {
  namespaced: true,
  state: {
    userLoggedIn: {
      name: "",
      id: "",
      category: "",
      userId: "",
      termsAccepted: false,
      features: [],
    },
    showConfirmationLogout: false,
  },
  getters: {
    getUserId(state) {
      return state.userLoggedIn.userId;
    },
    accountId(state) {
      return state.userLoggedIn.id;
    },
    getAccountType(state) {
      return state.userLoggedIn.category;
    },
    getUserName(state) {
      return state.userLoggedIn.name;
    },
    getAccountId(state) {
      return state.userLoggedIn.id;
    },
    getAllAccountFeatures(state) {
      return state.userLoggedIn.features;
    },
    getIsOrderCaptureEnabledForUser(state) {
      return state.userLoggedIn.features.includes(olfFeatures.FEATURE_ORDER_CAPTURE);
    },
    isPricingEngineEnabled(state) {
      return state.userLoggedIn.features && state.userLoggedIn.features.includes("pricingEngine");
    },
    isEditOrdersEnabled(state) {
      return state.userLoggedIn.features && state.userLoggedIn.features.includes("manageOrders");
    },
    isUpdateOrderNumbersEnabled(state) {
      return state.userLoggedIn.features && state.userLoggedIn.features.includes("manageOrderNumbers");
    },
  },
  actions: {
    logUserIn: ({ commit }, response) => {
      commit("LOGIN_USER", response);
    },
    logUserOut: ({ commit }) => {
      commit("LOGOUT_USER");
    },
    updateShowConfirmationLogout: ({ commit }, payload) => {
      commit("UPDATE_SHOW_CONFIRMATION_LOGOUT", payload);
    },
    updateTermsAcceptedStatus: ({ commit }, payload) => {
      commit("UPDATE_TERMS_ACCEPTED_STATUS", payload);
    },
    getAccountMetadata: async ({ commit, rootState }) => {
      await rootState.axios.get("/api/accountMetadata").then(async (res) => {
        commit("SET_ACCOUNT_METADATA", res.data);
      });
    },
  },
  mutations: {
    LOGIN_USER: (state, response) => {
      if (response.data.success) {
        const result = response.data;
        state.userLoggedIn.name = result.user.username;
        state.userLoggedIn.id = result.user.account.id;
        state.userLoggedIn.category = result.user.account.type;
        state.userLoggedIn.userId = result.user.userId;
      }
    },
    LOGOUT_USER: (state) => {
      if (localStorage.getItem("session")) {
        localStorage.removeItem("session");
      }
      state.userLoggedIn.name = "";
      state.userLoggedIn.id = "";
      state.userLoggedIn.category = "";
      state.userLoggedIn.userId = "";
    },
    UPDATE_SHOW_CONFIRMATION_LOGOUT: (state, payload) => {
      state.showConfirmationLogout = payload;
    },
    UPDATE_TERMS_ACCEPTED_STATUS: (state, payload) => {
      state.userLoggedIn.termsAccepted = payload;
    },
    SET_ACCOUNT_METADATA: (state, payload) => {
      state.userLoggedIn.features = payload.features;
    },
  },
};

export default login;
